import { Plus, Search } from "lucide-react";
import { Initials, RefillPill, Tags } from "./CrmBits";
import { fdate } from "./crmUtil";

export const FILTERS = [["all", "All"], ["refill", "Refill due"], ["followup", "Follow-up"], ["VIP", "VIP"], ["New", "New"], ["Inactive", "Inactive"]];

export const applyFilter = (rows, f, q, today) => rows.filter((c) =>
  (f === "all" || (f === "refill" ? c.refill && c.refill.days <= 7 : f === "followup" ? c.followups.some((x) => x.date <= today) : c.tags.includes(f))) &&
  `${c.name} ${c.phone} ${c.whatsapp} ${c.email} ${c.addresses.join(" ")}`.toLowerCase().includes(q.toLowerCase()));

export const FilterBar = ({ f, setF, q, setQ, onAdd }) => (
  <div className="space-y-2">
    <div className="flex gap-2">
      <div className="relative flex-1"><Search className="absolute left-2.5 top-2.5 h-4 w-4 text-slate-400" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search name, phone, email, address" className="w-full rounded-lg border bg-white py-2 pl-8 pr-3 text-sm focus:outline-none focus:ring-2 focus:ring-teal-500/40" data-testid="crm-search-input" /></div>
      {onAdd && <button onClick={onAdd} className="inline-flex items-center gap-1 rounded-lg bg-teal-600 px-3 text-sm font-semibold text-white hover:bg-teal-700" data-testid="crm-add-client-btn"><Plus className="h-4 w-4" /> Client</button>}
    </div>
    <div className="flex flex-wrap gap-1">{FILTERS.map(([k, l]) => (
      <button key={k} onClick={() => setF(k)} className={`shrink-0 rounded-full px-3 py-1 text-xs font-semibold transition-colors ${f === k ? "bg-[#0f1c2e] text-white" : "bg-white text-slate-600 hover:bg-slate-100"}`} data-testid={`crm-filter-chip-${k}`}>{l}</button>))}</div>
  </div>
);

export const ClientList = ({ rows, sel, onPick }) => (
  <div className="max-h-[70vh] space-y-1.5 overflow-y-auto pr-0.5">
    {rows.map((c) => (
      <button key={c.key} onClick={() => onPick(c.key)}
        className={`flex w-full items-center gap-3 rounded-xl border p-3 text-left transition-colors ${sel === c.key ? "border-teal-500 bg-teal-50" : "bg-white hover:border-slate-300"}`} data-testid={`crm-client-card-${c.key}`}>
        <Initials name={c.name} />
        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-1.5"><b className="truncate text-sm">{c.name}</b><Tags c={c} /></div>
          <div className="truncate text-xs text-slate-500">{c.orders ? `${c.orders} order${c.orders > 1 ? "s" : ""} · last ${fdate(c.last)}` : "No orders yet"}</div>
        </div>
        <RefillPill r={c.refill} />
      </button>))}
    {!rows.length && <p className="rounded-xl border bg-white p-6 text-center text-sm text-slate-400" data-testid="crm-empty">No clients match.</p>}
  </div>
);
